<div class="modal-header">
  <h4 class="modal-title synchpc-primary" id="modal-title">Reset Password Confirmation</h4>
  <i style="z-index: 1" class="bi bi-x-lg text-danger" color="warn" (click)="onClose()" title="Close"></i>
</div>
<div class="modal-body text-grey">
  <p>For resetting the password of User <strong>{{ selectedUser }}</strong>, please enter temporary password which will be used for login.</p>
  <br>
  <form [formGroup]="resetPassForm" spellcheck="false" autocomplete="off">
    <mat-form-field appearance="outline">
      <mat-label>New Password</mat-label>
      <input
        matInput
        placeholder="New Password"
        [type]="!fieldTextType ? 'text' : 'password'"
        formControlName="newPass"
      />
      <mat-icon
        *ngIf="resetPassForm.get('newPass').value != (null || '')"
        (click)="togglePassswordIcon(1)"
        matSuffix
        class="bi classPassIcon"
        [ngClass]="{
          'bi-eye-fill': fieldTextType,
          'bi-eye-slash-fill': !fieldTextType
        }"
      ></mat-icon>
      <mat-error
        *ngIf="
          resetPassForm.get('newPass').touched &&
          resetPassForm.get('newPass').errors?.required
        "
        >New Password Required*</mat-error
      >
    </mat-form-field>
    <mat-form-field appearance="outline">
      <mat-label>Confirm New Password</mat-label>
      <input
        matInput
        placeholder="Confirm New Passoword"
        [type]="!fieldTextType2 ? 'text' : 'password'"
        formControlName="confirmNewPass"
      />
      <mat-icon
        *ngIf="resetPassForm.get('confirmNewPass').value != (null || '')"
        (click)="togglePassswordIcon(2)"
        matSuffix
        class="bi classPassIcon"
        [ngClass]="{
          'bi-eye-fill': fieldTextType2,
          'bi-eye-slash-fill': !fieldTextType2
        }"
      ></mat-icon>
      <mat-error
        *ngIf="
          resetPassForm.get('confirmNewPass').touched &&
          resetPassForm.get('confirmNewPass').errors?.required
        "
        >Confirm Password Required*</mat-error
      >
    </mat-form-field>
  </form>
  <ngx-spinner
    bdColor="rgba(0,0,0,0)"
    size="default"
    zIndex="1"
    color="var(--s-primary-color)"
    type="ball-spin"
    [fullScreen]="false"
    ><p class="pleaseWait" style="margin-top: 3rem!important;">Please wait ...</p></ngx-spinner
  >
  <div class="text-center">
    <p class="text-danger">{{ errorMsg }}</p>
  </div>
</div>
<div class="modal-footer">
  <button type="button" class="btn btn-outline-secondary" (click)="onClose()">Cancel</button>
  <button type="button" class="btn btn-primary" (click)='onSubmit()'>
    Reset
  </button>
</div>